export const MUTINY_LOCAL_STORAGE_KEY = 'mutiny';

export const IS_MUTINY: string =
  typeof localStorage !== 'undefined' && localStorage.getItem(MUTINY_LOCAL_STORAGE_KEY) === 'true' ? 'true' : 'false';

export const CACHE_PREFIX: 'o-api' | 'p-api' = IS_MUTINY === 'true' ? 'o-api' : 'p-api';

export const APP: string = import.meta.env.VITE_APP || 'myaccount.ui';
export const WSS: string = import.meta.env.VITE_WSS || 'wss://wss.test.p2g.ninja';
export const VERSION: string = import.meta.env.VITE_VERSION || '0.0.0';
export const ENVIRONMENT: string = import.meta.env.VITE_ENVIRONMENT || '0.0.0';
export const CONTENT_API: string = import.meta.env.VITE_CONTENT_API_ORIGIN || '';
export const TRACKING_EDGE_API: string = import.meta.env.VITE_TRACKING_EDGE_API || 'https://api.global.test.p2g.ninja';
export const QUERY_API: string = import.meta.env.VITE_QUERY_API || 'https://query.test.p2g.ninja';
export const SELFSERVE_API: string = import.meta.env.VITE_SELFSERVE_API || 'https://selfserve-edge.test.p2g.ninja';
export const RULEMANAGER_API: string = import.meta.env.VITE_RULEMANAGER_API || 'https://rule-manager.test.p2g.ninja';
export const MY_API: string = import.meta.env.VITE_MY_API || '';
export const ACCOUNTLINKING_API: string =
  import.meta.env.VITE_ACCOUNTLINKING_API || 'https://accountlinking.test.p2g.ninja';
export const SMARTSEND_API: string = import.meta.env.VITE_SMARTSEND_API || '';
export const QUOTE_API: string = import.meta.env.VITE_QUOTE_API || '';
export const ORDERPROCESS_EDGE_API: string = import.meta.env.VITE_ORDERPROCESS_EDGE_API || '';
export const LABEL_API: string = import.meta.env.VITE_LABEL_API || '';
export const PAYMENT_PATH: string = import.meta.env.VITE_PAYMENT_PATH || '';
export const ANALYTICS_EDGE_API: string =
  import.meta.env.VITE_ANALYTICS_EDGE_API || 'https://api.global.test.p2g.ninja';
export const PAYMENT_API: string = import.meta.env.VITE_PAYMENT_API || '';
export const GTM_ENABLED: boolean = import.meta.env.VITE_GTM_ENABLED === 'true';
export const LOCAL_TENANT_OVERRIDE: string | null = import.meta.env.VITE_LOCAL_TENANT_OVERRIDE || null;
export const DEBOUNCE_TIME: number = parseInt(import.meta.env.VITE_DEBOUNCE_TIME || '750', 10);
export const LOCALES_PATH: string =
  import.meta.env.VITE_PUBLIC_LOCALES_PATH || 'https://apps.backoffice.parcel2go.com/~/.p2g/locales/';

export const AWS_REGION: string = import.meta.env.VITE_AWS_REGION || 'eu-west-1';

export const AWS_ACCESS_KEY: string = import.meta.env.VITE_AWS_ACCESS_KEY_ID || '';

export const AWS_ACCESS_SECRET: string = import.meta.env.VITE_AWS_SECRET_ACCESS_KEY || '';
export const INVOICE_API: string = import.meta.env.VITE_INVOICE_API || '';

export const TranslationNamespaces = {
  SELFSERVE: 'selfserve',
  MYACCOUNT: 'myaccount',
  COMMON: 'common',
  COUNTRY: 'country',
  STATEMENTS: 'statements',
  MYORDERS: 'myorders',
  MYDETAILS: 'mydetails',
  BILLING: 'billing',
  PREPAY: 'prepay',
  SETTINGS: 'user-settings',
  REWARDS: 'rewards',
  SURCHARGES: 'surcharges',
  COMMUNICATION_PREFERENCES: 'communication-preferences',
  ACCOUNT_LINKING: 'accounts',
  TRACKING: 'tracking',
  SAVED_ADDRESSES: 'addresses',
  SMARTSEND: 'smartsend',
  RULEMANAGER: 'rulemanager',
  SUPPORT_TICKET: 'support',
  CLAIMS: 'claims'
};

export const TRANSLATION_NAMESPACES_ARRAY = Object.values(TranslationNamespaces);

export const ContentGroups = {
  SELFSERVE: 'SelfServe',
  REWARDS: 'Rewards',
  MYACCOUNT: 'MyAccount',
  MYORDERS: 'MyOrders',
  STATEMENTS: 'Statements',
  MYDETAILS: 'MyDetails',
  PREPAY: 'PrePay',
  BILLING: 'Billing',
  SETTINGS: 'UserSettings',
  SURCHARGES: 'Surcharges',
  COMMUNICATION_PREFERENCES: 'CommunicationPreferences',
  ACCOUNT_LINKING: 'Accounts',
  SAVED_ADDRESSES: 'Addresses',
  SMARTSEND: 'SmartSend',
  RULEMANAGER: 'RuleManager',
  SUPPORT_TICKET: 'support',
  CLAIMS: 'claims'
};
